document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".stats-grid");

  blocks.forEach((block) => {
    initializeStatsGrid(block);
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".stats-grid")) {
    initializeStatsGrid(block);
  }

  block.querySelectorAll(".stats-grid").forEach((statsGridBlock) => {
    initializeStatsGrid(statsGridBlock);
  });
});

function initializeStatsGrid(blockElement) {
  const counters = blockElement.querySelectorAll("[data-stats-grid-number]");

  if (counters.length === 0) {
    return;
  }

  counters.forEach((counterElement) => {
    initializeStatsGridCounter(counterElement);
  });
}

function initializeStatsGridCounter(counterElement) {
  if (counterElement.dataset.statsGridInitialized === "true") {
    return;
  }

  counterElement.dataset.statsGridInitialized = "true";

  const targetValue = Number(
    counterElement.getAttribute("data-stats-grid-target"),
  );
  const decimals = Math.max(
    0,
    parseInt(counterElement.getAttribute("data-stats-grid-decimals") || "0", 10),
  );
  const duration = Math.max(
    1,
    parseInt(counterElement.getAttribute("data-stats-grid-duration") || "1600", 10),
  );

  if (!Number.isFinite(targetValue)) {
    return;
  }

  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const formatValue = (value) =>
    Number(value).toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });

  const renderValue = (value) => {
    counterElement.textContent = formatValue(value);
  };

  const finishAnimation = () => {
    counterElement.dataset.statsGridAnimated = "true";
    renderValue(targetValue);
  };

  const animateValue = () => {
    if (counterElement.dataset.statsGridAnimated === "true") {
      return;
    }

    let startTime = null;

    const step = (timestamp) => {
      if (startTime === null) {
        startTime = timestamp;
      }

      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = targetValue * easedProgress;

      renderValue(progress >= 1 ? targetValue : currentValue);

      if (progress < 1) {
        counterElement.__statsGridRaf = window.requestAnimationFrame(step);
        return;
      }

      finishAnimation();
      counterElement.__statsGridRaf = null;
    };

    counterElement.__statsGridRaf = window.requestAnimationFrame(step);
  };

  if (prefersReducedMotion) {
    finishAnimation();
    return;
  }

  renderValue(0);

  if (!("IntersectionObserver" in window)) {
    animateValue();
    return;
  }

  const observedElement =
    counterElement.closest(".stats-grid__item") || counterElement;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        observer.unobserve(entry.target);
        animateValue();
      });
    },
    {
      threshold: 0.35,
      rootMargin: "0px 0px -10% 0px",
    },
  );

  observer.observe(observedElement);
}
